import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React , { Fragment } from 'react';
import InfoGraphics from '../../components/home/InfoGraphics'
import styles from '../../styles/pages/about-us.module.scss';
import dynamic from "next/dynamic";
import { Hidden } from '@mui/material';
import {trackPage} from "../../tracking/index";
import { useRouter } from 'next/router';
import Config from '../../config';
import {getStaticPath} from '../../utils';
import { getPageViewData } from '../../utils/tracking';
import { WebsiteSchema } from '@/constants/schema';
import SchemaLoader from '@/components/hoc/SchemaLoader';
import PromotionalBanner from "../../components/home/PromotionalBanner"
import page_data from '../../data/page_data';

const LazyLoader = dynamic(()=> import("@/hoc/LazyLoader"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);

const WhatWeDo = dynamic(()=> import('../../components/about-us/WhatWeDo'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Team = dynamic(()=> import('../../components/about-us/Team'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const WhyToDo = dynamic(()=> import('../../components/about-us/WhyToDo'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const WhoAreWe = dynamic(()=> import('../../components/about-us/WhoAreWe'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Investors = dynamic(()=> import('../../components/about-us/Investor'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Partners = dynamic(()=> import('../../components/about-us/Partners'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const Fetcher = async () => {
  
  const data = {
    meta_tag_data: page_data["about-us"].meta_tag ? page_data["about-us"].meta_tag : [],
  }

  return data
}

export async function getServerSideProps() {
  const data = await Fetcher()
    return {
    props: { ...data, pageName: 'about-us' }
  }
}
export default function Home(props) {
  const router = useRouter();
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")
  
  React.useEffect(()=>{
    // document.documentElement.style.overflowY = "auto";
    trackPage("About Us Page",{...getPageViewData()})
},[props])

let cached_props:any = props || {}
  return (
    <Fragment>
      <Head>
        <title>{cached_props?.meta_tag_data?.tag_title}</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content={cached_props?.meta_tag_data?.tag_description}></meta>
        <meta property="og:title" content={cached_props?.meta_tag_data?.tag_title}/>
        <meta property="og:description" content={cached_props?.meta_tag_data?.tag_description}/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
        <SchemaLoader schema={WebsiteSchema} />
      </Head>
      <PromotionalBanner banners={[{
      desktop_image:'/static/images/selfserve/ew_banner_desktop.webp',
        tablet_image:'/static/images/selfserve/ew_banner_tablet.webp',
        mobile_image:'/static/images/selfserve/ew_banner_mobile.webp',
        name:'About-us banner',
      }]}/>
      <PlainBanner
        className={styles.contact_banner}
        title="India’s #1 Rated Device Protection Programme"
        subtitle="We’re the leading provider of device-care services in India and are driven by our mission to consistently deliver 'WOW' experiences to customers."/>

      <div className='odd-even-start-with-white'>

        <WhoAreWe />
        <Hidden mdUp>
            <InfoGraphics />
        </Hidden>
        <WhatWeDo />
        <LazyLoader>
          <WhyToDo />
        </LazyLoader>
        <LazyLoader>
          <Team />
        </LazyLoader>
        <LazyLoader>
          <Investors />
          <Partners IsHeading={false}/>
        </LazyLoader>
      </div>
    </Fragment>
  )
}
